import React from "react";
import Marquee from "react-fast-marquee";

const items = ["Sourcing", "Trading", "Logistics Coordination", "Worldwide", "Supplier Coordination", "Custom Procurement"];

export default function EditorialMarquee() {
  return (
    <section className="bg-navy py-6 overflow-hidden" data-testid="editorial-marquee" aria-hidden="true">
      <Marquee speed={40} gradient={false} autoFill>
        {items.map((item, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="font-heading font-bold text-[22px] lg:text-[30px] text-white/90 tracking-tight">{item}</span>
            <span className="h-2 w-2 rounded-full bg-copper" />
          </span>
        ))}
      </Marquee>
    </section>
  );
}
